import * as React from 'react';
import { cn } from '@/lib/utils';
import { FilterRow } from './filter';
import { FormCombobox } from '@/components/custom/form';

export const FilterCombobox = React.forwardRef(
  (
    {
      // props
      id,
      className,
      options = [],
      placeholder = 'Selecione...',
      loading = false,
      emptyMessage = 'Nenhum resultado encontrado.',
      label = '',
      multiple = false,
      fullWidth,
      disabled = false,
      ...props
    },
    ref
  ) => {
    return (
      <FilterRow
        ref={ref}
        className={cn(fullWidth ? 'md:w-full' : null, className)}
      >
        <FormCombobox
          id={id}
          options={options}
          placeholder={placeholder}
          loading={loading}
          emptyMessage={emptyMessage}
          label={label}
          multiple={multiple}
          disabled={disabled}
          {...props}
        />
      </FilterRow>
    );
  }
);

FilterCombobox.displayName = 'FilterCombobox';
